module.exports = __webpack_public_path__ + "static/media/class.823dda03.png";